import * as types from '../actions/action-types';
import _ from 'lodash';

export default (state = [], action) => {
  switch(action.type) {
    case types.showMessage:
      return [...state, {...action.message}];
    case types.hideMessage:
      return _.filter(state, value => value.id !== action.message.id);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/message-reducer.js